import { styled, css } from "styled-components";

import {
    BackgroundFieldValue,
    cssColorsFromBackgroundField,
    minWidth
} from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

type SectionProps = {
    background?: BackgroundFieldValue;
};

export const SectionWrapper = styled.div`
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("display", "grid")}
        ${redundantCssFromKebab("grid-auto-columns", "40fr 60fr")}
        ${redundantCssFromKebab("grid-auto-flow", "column")}
        ${redundantCssFromKebab("min-height", "100vh")}

        + footer {
            ${redundantCssFromKebab("display", "none")}
        }
    }
`;

const sharedSectionStyles = css`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-flow", "column")}
`;

export const SectionLeft = styled.section<SectionProps>(
    ({ background }) => background && cssColorsFromBackgroundField(background),
    {
        [`${sharedSectionStyles} header`]: {
            "@media (min-width: 992px)": {
                marginTop: "1.5rem",
                marginLeft: "1.5rem"
            }
        },

        footer: {
            "display": "none",
            "marginTop": "auto",
            "@media (min-width: 992px)": {
                display: "block"
            }
        }
    }
);

export const SectionRight = styled.section<SectionProps>(
    ({ background }) => background && cssColorsFromBackgroundField(background),
    sharedSectionStyles
);
